// removed by extract-text-webpack-plugin
module.exports = {"tags":"tags___3xfie","tag":"tag___3RKEn","tag-link":"tag-link___1vUAN","red-tag":"red-tag___3gmMs","blue-tag":"blue-tag___3WI-O","orange-tag":"orange-tag___3l23O","green-tag":"green-tag___ykZS7","purple-tag":"purple-tag___7i6o6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DiscoveryTags/DiscoveryTags.scss
// module id = RIJi
// module chunks = 57